import React from "react";
import {DepositPhase, DepositState, WithdrawPhase, WithdrawState} from "../../payments/PaymentsReducer";
import ChooseAddress from "../withdraw/ChooseAddress";
import WithdrawChooseAmount from "../withdraw/ChooseAmount";
import DepositChooseAmount from "../deposit/ChooseAmount";
import ConfirmWithdraw from "../withdraw/ConfirmWithdraw";
import WithdrawResponseView from "../withdraw/WithdrawResponseView";
import {t} from "../../i18n";
import {Redirect} from "react-router";
import {PaymentDialog, Settings} from "../../http/protocol";
import getLoggedInRedirect from "../../utils/LoggedInRedirect";
import {BrandA} from "../buttons/buttons";
import {OpenInNewWindow} from "../deposit/OpenInNewWindow";
import { ReactNode } from "react-markdown";

interface Props {
    type: string
    withdraw? : WithdrawState;
    handleClickOk?: () => void;
    handleClickStartPlaying?: () => void;
    deposit? : DepositState;
    dialog? : PaymentDialog;
    settings?: Settings;
    fromBonus?:boolean;
}

interface State {
    startPlaying:boolean;
}



type AllProps = Props;

export class TestPaymentComponent extends React.Component<AllProps, State> {
    constructor(props:AllProps) {
        super(props);

        this.state = {startPlaying:false}
    }

    renderWithdraw() {
        let withdraw = this.props.withdraw != undefined ? this.props.withdraw : {};
        let phase = withdraw && withdraw.phase;
        console.log("props: ", this.props?.withdraw?.withdrawResponse?.result)
        return(
            <div className="withdraw-title">
                {phase == WithdrawPhase.CHOOSE_PROVIDER && (
                    <ChooseAddress />
                )}
                {phase == WithdrawPhase.CHOOSE_AMOUNT && (
                    <WithdrawChooseAmount />
                )}
                {phase == WithdrawPhase.CONFIRM_WITHDRAW && (
                    <ConfirmWithdraw />
                )}
                {phase == WithdrawPhase.WITHDRAW_RESPONSE && withdraw && this.props.handleClickOk && (
                    <WithdrawResponseView onClick={this.props.handleClickOk}/>
                )}
                {phase === WithdrawPhase.REQUEST_DENIED && (
                    <div className="requestDenied">
                        <span>{t(`withdraw.requestDenied-reason.${withdraw.withdrawResponse?.result ?? 'ERROR'}`)}</span>
                    </div>
                )}
                {phase === WithdrawPhase.ERROR && (
                    <div className="requestDenied">
                        <span>{t("withdraw.withdrawError")}</span>
                    </div>
                )}
            </div>
        )
    }

    renderDeposit() {
        const phase = this.props.deposit && this.props.deposit.phase;
        const dialog = this.props.dialog;
        return(
            <div>
                {phase === DepositPhase.CHOOSE_AMOUNT && (
                    <DepositChooseAmount/>
                )}
                {phase === DepositPhase.PROVIDER_CONTENT && (
                    <div>
                        {dialog && dialog.iframeUrl && !dialog.openInNewWindow && <iframe className={""} frameBorder={0} src={dialog.iframeUrl} width={"100%"} height={"250px !important"}/>}
                        {dialog && dialog.iframeUrl && dialog.openInNewWindow && <OpenInNewWindow url={dialog.iframeUrl} />}
                        {!dialog?.openInNewWindow && this.props.handleClickStartPlaying && <BrandA className={"btn btn-cta full-width large"} onClick={this.props.handleClickStartPlaying}>{t("global.startPlaying")}</BrandA>}
                    </div>
                )}
            </div>
        )
    }

    render(): ReactNode | ReactNode[] {
        if(this.state.startPlaying && this.props.settings) {
            return <Redirect to={getLoggedInRedirect(this.props.settings)} />
        }

        if(this.props.type == "withdraw") {
            return this.renderWithdraw()
        }
        if(this.props.type == "deposit") {
            return  this.renderDeposit()
        }
    }
}